// 商品ページの価格の注記（.price_desc、おちゃのこ標準文言「オプションにより価格が変わる場合もあります。」）を
// 「枚数により単価が変わります。」に置き換える（Issue #78）。
// おちゃのこの商品ページ欄に 3 店（fukuro.in / あんしんや / 台紙販売）で同じ直書きがあった:
//   $(document).ready(function () { $('.price_desc').html('枚数により単価が変わります。'); });
// ★ パックジャパン(6) には足さない（標準文言のまま出ている。現行どおり）。対象店は shared/hooks.ts の PRICE_DESC_SITES。
// ★ 過渡期（直書きと hook が両方いる）も同じ文字列を 2 回入れるだけなので害は無い（ガード不要）。
// ★ .according_options の文言置換（fukuro の TS とパックジャパンの直書き）は対象の要素がどの店にも無いので移さない。

export const PRICE_DESC_TEXT = '枚数により単価が変わります。'

/** .price_desc の中身を置き換える。戻り値は置き換えた数 */
export function applyPriceDescNote(doc: ParentNode, text: string = PRICE_DESC_TEXT): number {
  const found = doc.querySelectorAll<HTMLElement>('.price_desc')
  found.forEach((el) => {
    el.textContent = text
  })
  return found.length
}

export default function priceDescNote(): void {
  applyPriceDescNote(document)
}
